import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
}

const defaultProps = {
  width: 13,
  height: 13,
  color: '#5badfa',
}

// Component
function IconArrowLeft({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8.228 13.93"
      width={width}
      height={height}
      color={color}
    >
      <g transform="translate(8.228) rotate(90)">
        <path
          fill="#5badfa"
          d="M13.707,101.386l-.456-.459a.764.764,0,0,0-1.078,0l-5.205,5.205L1.757,100.92a.764.764,0,0,0-1.078,0l-.456.457a.763.763,0,0,0,0,1.078l6.2,6.227a.779.779,0,0,0,.54.244h0a.779.779,0,0,0,.539-.244l6.2-6.21a.77.77,0,0,0,.223-.544A.762.762,0,0,0,13.707,101.386Z"
          transform="translate(0 -100.698)"
        />
      </g>
    </svg>
  )
}

IconArrowLeft.propTypes = propTypes
IconArrowLeft.defaultProps = defaultProps

export default IconArrowLeft
